// extracted by mini-css-extract-plugin
module.exports = {"list":"service-info-list_list__BWs5J","item":"service-info-list_item__11bND"};